import { images } from '../constants';

const services = [
{
  id: 1,
  image: images.service1,
  title: 'Regular Laundry',
  content: 'Trust us with your everyday clothing items. Our regular laundry service ensures cleanliness for your daily wear.',
  paragraphs: [
    'Our regular laundry service is designed to keep your everyday clothes fresh, clean, and ready to wear. We handle a variety of fabrics with care to maintain quality and comfort.',
    'Using eco-friendly detergents and modern machines, we ensure thorough cleaning and gentle treatment for all your garments. Perfect for daily wear, work clothes, and casual outfits.'
  ],
  gallery: [
    images.service1Gallery1,
    images.service1Gallery2,
  ],
  features: [
    'Careful Fabric Handling',
    'Eco-Friendly Cleaning Products',
    'Quick Turnaround Times',
    'Affordable Pricing',
    'Convenient Pickup & Delivery'
  ],
  procedure: [
    'Schedule Pickup',
    'Garment Sorting and Inspection',
    'Cleaning and Washing',
    'Quality Check and Folding',
    'Delivery to Your Doorstep'
  ],
  faqs: [
    {
      id: 1,
      heading: 'What types of clothes can I send for regular laundry?',
      content: 'We accept all common fabrics including cotton, polyester, linen, and blends used in everyday clothing.'
    },
    {
      id: 2,
      heading: 'How long does the regular laundry process take?',
      content: 'Most regular laundry orders are completed within 24 to 48 hours depending on volume and schedule.'
    },
    {
      id: 3,
      heading: 'Do you use any harsh chemicals?',
      content: 'No, we use environmentally friendly and skin-safe detergents that are tough on stains but gentle on fabrics.'
    },
    {
      id: 4,
      heading: 'Is pickup and delivery available?',
      content: 'Yes, we offer convenient pickup and delivery services to save you time and effort.'
    }
  ]
},
{
  id: 2,
  image: images.service2,
  title: 'Dry Cleaning',
  content: 'For delicate fabrics and special garments, our dry cleaning service ensures attention to detail for a spotless finish.',
  paragraphs: [
    'Our dry cleaning process is specially designed for delicate and high-value garments that require gentle yet effective cleaning. We use premium solvents and techniques to preserve fabric integrity and color vibrancy.',
    'From silk dresses to tailored suits, we handle each item with care, ensuring stains and odors are removed without damage. Trust us to keep your special garments looking pristine and fresh.'
  ],
  gallery: [
    images.service2Gallery1,
    images.service2Gallery2,
  ],
  features: [
    'Specialized Fabric Care',
    'Eco-Friendly Solvents',
    'Stain and Odor Removal',
    'Color Preservation Techniques',
    'Expert Handling of Delicates'
  ],
  procedure: [
    'Garment Inspection and Tagging',
    'Spot Treatment of Stains',
    'Dry Cleaning with Gentle Solvents',
    'Professional Pressing and Finishing',
    'Final Quality Check and Packaging'
  ],
  faqs: [
    {
      id: 1,
      heading: 'Which fabrics are suitable for dry cleaning?',
      content: 'Dry cleaning is ideal for delicate fabrics like silk, wool, velvet, and garments with intricate detailing or embellishments.'
    },
    {
      id: 2,
      heading: 'Is dry cleaning safe for all colors?',
      content: 'Yes, our process is designed to preserve colors and prevent fading while removing dirt and stains effectively.'
    },
    {
      id: 3,
      heading: 'How long does dry cleaning take?',
      content: 'Typically, dry cleaning is completed within 48 hours, depending on the item and workload.'
    },
    {
      id: 4,
      heading: 'Do you offer pickup and delivery for dry cleaning?',
      content: 'Yes, we provide convenient pickup and delivery services for your dry cleaning needs.'
    }
  ]
},
{
  id: 3,
  image: images.service3,
  title: 'Stain Removal',
  content: 'We specialize in effective stain removal techniques, ensuring your clothes are free from stubborn stains and blemishes.',
  paragraphs: [
    'Our expert stain removal service targets a wide variety of tough stains, from wine and coffee to ink and grease, using safe and advanced cleaning solutions.',
    'We carefully treat each garment to protect the fabric while eliminating blemishes, restoring your clothes to their original look without damage.'
  ],
  gallery: [
    images.service3Gallery1,
    images.service3Gallery2,
  ],
  features: [
    'Targeted Stain Treatment',
    'Safe for All Fabrics',
    'Advanced Cleaning Solutions',
    'Preserves Fabric Integrity',
    'Eco-Friendly Methods'
  ],
  procedure: [
    'Garment Inspection and Stain Identification',
    'Pre-Treatment with Specialized Solutions',
    'Gentle Cleaning and Extraction',
    'Post-Treatment Quality Check',
    'Final Pressing and Packaging'
  ],
  faqs: [
    {
      id: 1,
      heading: 'What types of stains can you remove?',
      content: 'We can effectively remove most common stains, including coffee, wine, ink, grease, and food stains.'
    },
    {
      id: 2,
      heading: 'Is stain removal safe for delicate fabrics?',
      content: 'Yes, we use fabric-safe treatments that protect delicate materials while removing stains.'
    },
    {
      id: 3,
      heading: 'How long does the stain removal process take?',
      content: 'Typically, stain removal is completed within 24 to 48 hours depending on the stain severity and fabric type.'
    },
    {
      id: 4,
      heading: 'Can all stains be completely removed?',
      content: 'While we strive to remove all stains, some may be permanent depending on the fabric and stain age.'
    }
  ]
},
{
  id: 4,
  image: images.service4,
  title: 'Fabric Alterations',
  content: 'Our skilled tailors provide expert fabric alterations to ensure your clothes fit perfectly.',
  paragraphs: [
    'We offer a range of alteration services including hemming, resizing, tapering, and repairing garments to enhance comfort and style.',
    'Our experienced tailors work with precision to adjust your clothes according to your measurements and preferences, ensuring a flawless fit.'
  ],
  gallery: [
    images.service4Gallery1,
    images.service4Gallery2,
  ],
  features: [
    'Professional Tailoring Adjustments',
    'Custom Fit Alterations',
    'Hemming and Resizing',
    'Repair and Restoration',
    'Quick Turnaround Time'
  ],
  procedure: [
    'Initial Consultation and Measurement',
    'Assessment of Alteration Needs',
    'Precise Tailoring and Adjustment',
    'Final Fitting and Quality Check',
    'Ready for Pickup or Delivery'
  ],
  faqs: [
    {
      id: 1,
      heading: 'What types of alterations do you offer?',
      content: 'We provide hemming, resizing, tapering, patching, zipper replacement, and other garment adjustments.'
    },
    {
      id: 2,
      heading: 'How long does an alteration usually take?',
      content: 'Most alterations are completed within 2 to 5 days, depending on the complexity.'
    },
    {
      id: 3,
      heading: 'Can you alter delicate or expensive fabrics?',
      content: 'Yes, our tailors are skilled in handling delicate and high-end fabrics with care.'
    },
    {
      id: 4,
      heading: 'Do you offer custom tailoring services?',
      content: 'While our focus is on alterations, we also offer some custom tailoring to modify garment styles as requested.'
    }
  ]
},
{
  id: 5,
  image: images.service5,
  title: 'Express Service',
  content: 'Need your laundry done quickly? Try our express service for fast and efficient turnaround.',
  paragraphs: [
    'Our express laundry service guarantees speedy processing without compromising on quality. Perfect for last-minute needs or busy schedules.',
    'We prioritize your orders to ensure quick washing, drying, and folding, so you can get your clothes back faster than ever.'
  ],
  gallery: [
    images.service5Gallery1,
    images.service5Gallery2,
  ],
  features: [
    'Fast Turnaround Times',
    'Priority Handling',
    'Quality Cleaning',
    'Convenient Pickup and Delivery',
    'Suitable for All Garment Types'
  ],
  procedure: [
    'Order Placement with Express Option',
    'Priority Processing and Cleaning',
    'Quality Check and Packaging',
    'Express Delivery or Pickup'
  ],
  faqs: [
    {
      id: 1,
      heading: 'How fast is the express service?',
      content: 'Most express orders are completed within 24 hours.'
    },
    {
      id: 2,
      heading: 'Is there an extra cost for express service?',
      content: 'Yes, a nominal surcharge applies for faster processing.'
    },
    {
      id: 3,
      heading: 'Can I use express service for all laundry items?',
      content: 'Yes, express service is available for all garment types.'
    },
    {
      id: 4,
      heading: 'How do I request express service?',
      content: 'Simply select the express option when placing your order online or inform our customer service.'
    }
  ]
},
{
  id: 6,
  image: images.service6,
  title: 'Eco-Friendly Cleaning',
  content: 'Our eco-friendly cleaning service ensures a sustainable and environmentally conscious approach to laundry.',
  paragraphs: [
    'We use biodegradable detergents and energy-efficient machines to minimize environmental impact while delivering spotless cleaning results.',
    'Our process prioritizes water conservation and responsible waste management, making your laundry greener and cleaner.'
  ],
  gallery: [
    images.service6Gallery1,
    images.service6Gallery2,
  ],
  features: [
    'Biodegradable Detergents',
    'Energy-Efficient Washing Machines',
    'Water Conservation Practices',
    'Reduced Chemical Usage',
    'Eco-Friendly Packaging Options'
  ],
  procedure: [
    'Order Placement',
    'Sorting and Eco-Friendly Washing',
    'Eco-Friendly Drying and Folding',
    'Sustainable Packaging and Delivery'
  ],
  faqs: [
    {
      id: 1,
      heading: 'What makes your cleaning eco-friendly?',
      content: 'We use environmentally safe detergents and machines designed to reduce water and energy consumption.'
    },
    {
      id: 2,
      heading: 'Is eco-friendly cleaning as effective as traditional cleaning?',
      content: 'Yes, our eco-friendly methods maintain high cleaning standards without harming the environment.'
    },
    {
      id: 3,
      heading: 'Does eco-friendly cleaning cost more?',
      content: 'The cost is comparable to our regular service, with optional upgrades for premium eco-friendly products.'
    },
    {
      id: 4,
      heading: 'Can I choose eco-friendly cleaning for all types of laundry?',
      content: 'Yes, eco-friendly cleaning is suitable for most fabrics and garment types.'
    }
  ]
}

];

export default services;